export const EMPTY_VALUE = "-";
export const COPY_FEEDBACK_MS = 1500;
export const DEFAULT_TRUNCATE_LENGTH = 10;

const VISIBLE_EDGE_LENGTH = 4;

export function truncateString(
  value,
  maxLength = DEFAULT_TRUNCATE_LENGTH,
) {
  const text = String(value);
  if (text.length <= maxLength) {
    return text;
  }
  return `${text.slice(0, VISIBLE_EDGE_LENGTH)}...${text.slice(-VISIBLE_EDGE_LENGTH)}`;
}

export function hasValue(value) {
  return value !== undefined && value !== null && value !== "";
}

export async function copyToClipboard(value) {
  await navigator.clipboard.writeText(String(value));
}
